import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

type SkillsEditModalProps = {
  show: boolean;
  skills: string[];
  saving?: boolean;
  onHide: () => void;
  onSave: (skills: string[]) => Promise<boolean>;
};

export default function SkillsEditModal({
  show,
  skills,
  saving = false,
  onHide,
  onSave,
}: SkillsEditModalProps) {
  const [value, setValue] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (show) {
      setValue(skills.join(', '));
    }
  }, [show, skills]);

  const handleSave = async () => {
    const next = value
      .split(',')
      .map((skill) => skill.trim())
      .filter(Boolean);
    setSubmitting(true);
    try {
      const saved = await onSave(next);
      if (saved) {
        onHide();
      }
    } finally {
      setSubmitting(false);
    }
  };

  const busy = saving || submitting;

  return (
    <Modal show={show} onHide={onHide} centered size="lg" className="ss-app-modal">
      <Modal.Header closeButton>
        <Modal.Title>Edit skills</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ssr-modal-body">
        <Form.Group>
          <Form.Label>Skills</Form.Label>
          <Form.Control
            as="textarea"
            rows={8}
            className="ssr-field-input ssr-field-textarea ssr-field-textarea--lg"
            value={value}
            onChange={(event) => setValue(event.target.value)}
            placeholder="Comma-separated skills, e.g. React, Python, AWS"
          />
          <Form.Text muted>Separate skills with commas.</Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide} disabled={busy}>
          Cancel
        </Button>
        <Button variant="success" onClick={() => void handleSave()} disabled={busy}>
          {busy ? 'Saving…' : 'Save skills'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
